import { Flex, LssProp, styled } from '@lucidhq/lucidium';

const BaseLoader = styled(Flex)`
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.7) 20%,
      rgba(255, 255, 255, 0) 80%
    ),
    #eeeeee;
  background-repeat: repeat-y;
  background-size: 50px 500px;
  background-position: 0 0;
  animation: shine 3s infinite;

  @keyframes shine {
    to {
      background-position:
        105% 0,
        0 0;
    }
  }
`;

export interface SkeletonBarProps {
  lss?: LssProp;
  ariaLabel?: string;
}

export const SkeletonBar = ({ lss, ariaLabel }: SkeletonBarProps) => (
  <BaseLoader
    aria-label={ariaLabel}
    lss={{
      width: '100%',
      height: '1.5rem',
      bg: 'gray200',
      borderRadius: 'sm',
      ...lss,
    }}
  />
);
